export const FORM1094C_LOADING_STATES = {
    CONFIGURATIONS_LOADING: "CONFIGURATIONS_LOADING",
    CONFIGURATIONS_READY: "CONFIGURATIONS_READY",
    DEPENDENT_FIELD_CHANGE_LOADING: "DEPENDENT_FIELD_CHANGE_LOADING",
    DEPENDENT_FIELD_CHANGE_READY: "DEPENDENT_FIELD_CHANGE_READY",
    SAVE_FORM_LOADING: "SAVE_FORM_LOADING",
    SAVE_FORM_READY: "SAVE_FORM_READY",
}

export const FORM1094C_STATES_MESSAGE_MAP = {
    [FORM1094C_LOADING_STATES.CONFIGURATIONS_LOADING]: "",
    [FORM1094C_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING]: "",
    [FORM1094C_LOADING_STATES.SAVE_FORM_LOADING]: "",
}